import styled from "styled-components";

export const Container = styled.div`
//color: #9880ff original color
  position: relative;
  width: 7px;
  height: 7px;
  border-radius: 5px;
  background-color: #535252;
  color: #535252;
  animation: dotFlashing 1s infinite linear alternate;
  animation-delay: .5s;

::before, ::after {
  content: '';
  display: inline-block;
  position: absolute;
  top: 0;
}

::before {
  left: -20px;
  width: 7px;
  height: 7px;
  border-radius: 5px;
  background-color: #535252;
  color: #535252;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 0s;
}

::after {
  left: -10px;
  width: 7px;
  height: 7px;
  border-radius: 5px;
  background-color: #535252;
  color: #535252;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 1s;
}

@keyframes dotFlashing {
  0% {
    background-color: #535252;
  }
  50%,
  100% {
    background-color: #ebe6ff;
  }
}
`